import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Header from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import Home from './components/Home/Home';
import About from './components/About/About';
import Products from './components/Products/Products';
import Contact from './components/Contact/Contact';

const App: React.FC = () => {
 // State to control button visibility
 const [isVisible, setIsVisible] = useState(false);

 // Scroll event handler
 const handleScroll = () => {
   if (window.scrollY > 200) {
     setIsVisible(true);  // Show the button after 200px scroll
   } else {
     setIsVisible(false); // Hide the button when at the top
   }
 };

 // Smooth scroll to the top
 const scrollToTop = () => {
   window.scrollTo({ top: 0, behavior: 'smooth' });
 };

 useEffect(() => {
   // Adding the scroll event listener
   window.addEventListener('scroll', handleScroll);

   // Cleanup on component unmount
   return () => {
     window.removeEventListener('scroll', handleScroll);
   };
 }, []);


  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/products" element={<Products />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
        <button
        className={`scroll-to-top ${isVisible ? 'visible' : ''}`}
        onClick={scrollToTop}
      >
        <span>&#8593;</span> {/* Unicode arrow for the "up" symbol */}
      </button>
      </div>
    </Router>
  );
};

export default App;
